<ng-container *ngIf="maxLengthError">This field contains {{maxLengthError.actualLength}} characters, but has a maximum length of {{maxLengthError.requiredLength}}</ng-container>
